module.exports = __webpack_public_path__ + "static/media/stamp-chosen.698cba40.png";